(function($){
	//Handle the FAQ toggling
	$(document).on('click', '.archive-item.faq .title', function(e) {
		// If clicking a link within the FAQ, don't toggle it closed
		if(e.target.tagName == "A" || e.target.tagName == "a") {
			e.stopPropagation();
		}
		else {
			$(this).find('.fa-sm').toggleClass('down');
			$(this).closest('.archive-item.faq').toggleClass('open').find('.answer').slideToggle();
		}
	});

	if ($('body.page-template-faq-archive-by-category').length) {
		//Print button
		$(document).on('click', '.print-faqs', function(e) {
			e.preventDefault();

			window.print();
		});

		//Copy answer link to clipboard
		$(document).on('click', '.archive-item.faq .copy-answer-link', function(e) {
			e.preventDefault();
			e.stopPropagation();

			//Build the URL
			const $button = $(this);
			let url = window.location.origin + window.location.pathname + $button.attr('data-target');

			navigator.clipboard.writeText(url).then(function() {
	            $link = $button.find('.link');
	            $checkmark = $button.find('.checkmark');

	            $link.hide();
	            $checkmark.fadeIn(300, function() {
	            	window.setTimeout(function() {
	            		$checkmark.hide();
	            		$link.fadeIn(300);
	            	}, 1000);
	            });
	        }).catch(function(err) {
	            console.error('Failed to copy text: ', err);
	        });
		});

		//On load, if there is a hash that's an FAQ, open the FAQ
		if (window.location.hash && $(window.location.hash).length) {
			$faq = $(window.location.hash);

			if ($faq && $faq.hasClass('faq')) {
				$faq.find('.fa-sm').addClass('down');
				$faq.closest('.archive-item.faq').find('.answer').slideDown();

				//Highlight the active category
				$heading = $faq.prevAll('.category-heading').first();

				if ($heading) {
					$link = $('nav.faq-categories a[href=#'+$heading.attr('id')+']');

					if ($link) {
						$link.parent().addClass('active');
					}
				}
			}
			else if ($faq && $faq.hasClass('category-heading')) {
				$link = $('nav.faq-categories a[href=#'+$faq.attr('id')+']').first();

				if ($link) {
					$link.parent().addClass('active');
				}
			}
		}
		else {
			$('nav.faq-categories li:first-child').addClass('active');
		}

		//On scroll/resize, deal with the active state on the sticky navigation
		window.addEventListener('scroll', updateActiveStickyMenu);
		window.addEventListener('resize', updateActiveStickyMenu);
		
		function updateActiveStickyMenu() {
			var $currentHeading = getClosestSection('.category-heading');

			if ($currentHeading) {
				$link = $('nav.faq-categories a[href=#'+$currentHeading.attr('id')+']');

				//If the link is already active, nothing else needed
				if ($link && !$link.parent().hasClass('active')) {
					//Remove active from the current one
					$('nav.faq-categories li.active').removeClass('active');

					//Add active to the new one
					$link.parent().addClass('active');
				}
			}
		}

		function getClosestSection(selector) {
			var $closestAbove = null;
			var maxBottom = -Infinity;

			$(selector).each(function() {
				var rect = this.getBoundingClientRect();
				var bottomY = rect.bottom;

				// Check if the element is above the viewport (bottom edge < 0)
				if (bottomY < 250 && bottomY > maxBottom) {
					maxBottom = bottomY;
					$closestAbove = $(this);
				}
			});

			return $closestAbove; 
		}

		//On load, update the print date, in case of cache
		$('.print-date').html(new Date().toLocaleDateString('en-CA'));

		//When clicking an item from the sidebar, add the active class
		$(document).on('click', 'nav.faq-categories a', function(e) {
			$(this).closest('nav.faq-categories').find('.active').removeClass('active');
			$(this).parent().addClass('active');
		});

		//Local filtering for the new FAQs, since they are all loaded into the DOM already
		$('#filter-sidebar').on('submit', function(e) {
			e.preventDefault();
		});

		var faqSearchTimeout;

		$('#filter-sidebar #keyword-filter').on('keyup', function (e) {
	        var self = this;

	        if (this.value == '') {
	            setTimeout( function () {
	                clearTimeout( faqSearchTimeout );
	                faqSearchTimeout = setTimeout( function () {
	                	filterFaqs();
	                }, 300 );
	            }, 5);
	        } else {
	            clearTimeout( faqSearchTimeout );
	            faqSearchTimeout = setTimeout( function () {
	            	filterFaqs();
	            }, 300 );
	        }
	    });

	    function filterFaqs() {
			const search = $('#filter-sidebar #keyword-filter').val();

			if (!search.length) {
				$('.archive-item.faq').removeClass('hidden').show();
			} else {
				$('.archive-item.faq').each(function () {
					const faqText = $(this).text().toLowerCase();
					const searchText = search.toLowerCase();

					if (faqText.includes(searchText)) {
						$(this).removeClass('hidden').show();
					} else {
						$(this).addClass('hidden').hide();
					}
				});
			}

			toggleFaqCategoryMessages();
		}

		function toggleFaqCategoryMessages() {
			$('.category-heading').each(function () {
				const $heading = $(this);

				const $faqsInCategory = $heading
					.nextUntil('.category-heading', '.archive-item.faq:not(.hidden)');

				const hasVisibleFaqs = $faqsInCategory.length > 0;

				$heading
					.next('.faq-category-empty-message')
					.toggle(!hasVisibleFaqs);
			});
		}
	}

})(jQuery);
